import { OrderImportedFromXLS, DoorSize, ErrorSheet } from './interfaces'
import { LockerDimensionsList, LockerXL } from './lockers'
const expressionEmail: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

let rowErrors: Array<ErrorSheet> = []

export const cleanRowErrores = () => {
    rowErrors = []
}

export const processOrderAddress = (
    order: OrderImportedFromXLS,
    rowNumber: number
): any => {
    try {
        if (order.DepositCode !== null && order.DepositCode !==undefined && (order.DepositCode.toString().length < 3 || order.DepositCode.toString().length > 20))
            rowErrors.push({ row: rowNumber, message: `El código de depósito debe tener entre 3 y 20 caracteres` })

        if (!order.ClientMail) {
            rowErrors.push({ row: rowNumber, message: 'El correo electrónico es obligatorio' })
        } else {
            if (!expressionEmail.test(order.ClientMail))
                rowErrors.push({ row: rowNumber, message: `El mail '${order.ClientMail}' no es válido` })
        }

        if (!order.ClientName)
            rowErrors.push({ row: rowNumber, message: `El nombre del cliente es obligatorio` })

        // if (!order.clientPhone) 
        //     rowErrors.push({ row: rowNumber, message: `El teléfono del cliente es obligatorio` })

        if (!order.Alias)
            rowErrors.push({ row: rowNumber, message: `El alias es obligatorio` })

        if (order.ParcelWeightInGrams == null || !(parseInt(order.ParcelWeightInGrams.toString()) > 0))
            rowErrors.push({ row: rowNumber, message: `El peso del paquete es obligatorio` })

        if (!order.StreetName)
            rowErrors.push({ row: rowNumber, message: `La calle es obligatoria` })

        if (!order.StreetNumber)
            rowErrors.push({ row: rowNumber, message: `La altura de la calle es obligatoria` })

        if (!order.City)
            rowErrors.push({ row: rowNumber, message: `La ciudad es obligatoria` })

        if (!order.CountrySubdivision)
            rowErrors.push({ row: rowNumber, message: `La provincia es obligatoria` })

        if (!order.PostalCode || Number.isNaN(parseInt(order.PostalCode!.toString()))) {
            rowErrors.push({ row: rowNumber, message: `El código postal es obligatorio` })
        } else {
            if (parseInt(order.PostalCode!) < 1000 || parseInt(order.PostalCode!) > 9999)
                rowErrors.push({ row: rowNumber, message: `El código postal no es valido` })
        }

        if (order.RequestSignature === 'true' || order.RequestToken === 'true' || order.CustomCodeType || order.CustomCode) {
            rowErrors.push({ row: rowNumber, message: `Los envíos a domicilio no admiten código de seguridad` })
        }

        return rowErrors
    } catch (e) {
        console.error(e)
        rowErrors.push({ row: rowNumber, message: `El registro presenta errores de formato.` })
    }
}

export const calculateDoorSize = (order: OrderImportedFromXLS): any => {
    const packageDimensions = [
        order.ParcelWidthInMm,
        order.ParcelHeightInMm,
        order.ParcelLengthInMm,
    ]
    packageDimensions.sort(function (a, b) {
        return a! - b!
    })

    let assignedLocker = null

    LockerDimensionsList.every((locker) => {
        const lockerDimensions = [locker.height, locker.width, locker.length]
        lockerDimensions.sort(function (a, b) {
            return a! - b!
        })

        if (lockerDimensions[0] < packageDimensions[0]!) {
            return true
        }
        if (lockerDimensions[1] < packageDimensions[1]!) {
            return true
        }
        if (lockerDimensions[2] < packageDimensions[2]!) {
            return true
        }
        assignedLocker = locker.sizeNumber
        return false
    })
    return assignedLocker
}

export const calculateDoorSizeText = (order: OrderImportedFromXLS): any => {
    const packageDimensions = [
        order.ParcelWidthInMm,
        order.ParcelHeightInMm,
        order.ParcelLengthInMm,
    ]
    packageDimensions.sort(function (a, b) {
        return a! - b!
    })

    let assignedLocker = null

    LockerDimensionsList.every((locker) => {
        const lockerDimensions = [locker.height, locker.width, locker.length]
        lockerDimensions.sort(function (a, b) {
            return a! - b!
        })

        if (lockerDimensions[0] < packageDimensions[0]!) {
            return true
        }
        if (lockerDimensions[1] < packageDimensions[1]!) {
            return true
        }
        if (lockerDimensions[2] < packageDimensions[2]!) {
            return true
        }
        assignedLocker = locker.id
        return false
    })
    return assignedLocker
}

export const processOrderLocker = (order: OrderImportedFromXLS, rowNumber: number) => {
    let doorSize: DoorSize = DoorSize.error
    const customCodeType = order.CustomCodeType && order.CustomCodeType.toString().toLowerCase()
    const customCode = order.CustomCode && order.CustomCode.toString().toLowerCase()
    try {
        if (order.DepositCode !== null && order.DepositCode !==undefined && (order.DepositCode.toString().length < 3 || order.DepositCode.toString().length > 20))
            rowErrors.push({ row: rowNumber, message: `El código de depósito debe tener entre 3 y 20 caracteres` })
        if (customCodeType && customCodeType === 'dni' 
            && customCode && customCode.length < 3)
            rowErrors.push({ row: rowNumber, message: `El código de seguridad no es válido.` })
        if (customCodeType && customCodeType === 'dni' 
            && customCode && !/^\d*$/.test(customCode))
            rowErrors.push({ row: rowNumber, message: `El código de seguridad no es válido.` })
        if (customCodeType === 'alphanumeric' 
            && customCode && customCode.length < 3)
            rowErrors.push({ row: rowNumber, message: `El código de seguridad no es válido.` })
        if (!order.ClientMail) {
            rowErrors.push({ row: rowNumber, message: 'El correo electrónico es obligatorio' })
        } else {
            if (!expressionEmail.test(order.ClientMail))
                rowErrors.push({ row: rowNumber, message: `El mail '${order.ClientMail}' no es válido` })
        }

        if (!order.ClientName)
            rowErrors.push({ row: rowNumber, message: `El nombre del cliente es obligatorio` })

        // if (!order.ClientPhone) 
        //     rowErrors.push({ row: rowNumber, message: `El teléfono del cliente es obligatorio` })

        if (!order.Alias)
            rowErrors.push({ row: rowNumber, message: `El alias es obligatoria` })

        if (order.ParcelWeightInGrams == null || !(parseInt(order.ParcelWeightInGrams.toString()) > 0))
            rowErrors.push({ row: rowNumber, message: `El peso del paquete es obligatorio` })

        if (
            order.ParcelHeightInMm != null && (parseInt(order.ParcelHeightInMm.toString())>0) && order.ParcelHeightInMm < LockerXL.height &&
            order.ParcelLengthInMm != null && (parseInt(order.ParcelLengthInMm.toString())>0) && order.ParcelLengthInMm < LockerXL.length &&
            order.ParcelWidthInMm != null && (parseInt(order.ParcelWidthInMm.toString())>0) && order.ParcelWidthInMm < LockerXL.width
        ) {
            doorSize = calculateDoorSize(order)
        } else {
            rowErrors.push({
                message: `Alguno de los 3 valores asociados al tamaño de la puerta es incorrecto`,
                row: rowNumber,
            })
        }
        return {
            doorSize: doorSize,
            errors: rowErrors || [],
        }
    } catch (e) {
        console.error(e)
        rowErrors.push({ row: rowNumber, message: `El registro presenta errores de formato.` })
    }
}
